var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04427 11.6668C6.04427 11.3217 6.32409 11.0418 6.66927 11.0418L13.3359 11.0418C13.6811 11.0418 13.9609 11.3217 13.9609 11.6668C13.9609 12.012 13.6811 12.2918 13.3359 12.2918L6.66927 12.2918C6.32409 12.2918 6.04427 12.012 6.04427 11.6668Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04427 8.3335C6.04427 7.98832 6.32409 7.7085 6.66927 7.7085H8.33594C8.68112 7.7085 8.96094 7.98832 8.96094 8.3335C8.96094 8.67867 8.68112 8.9585 8.33594 8.9585H6.66927C6.32409 8.9585 6.04427 8.67867 6.04427 8.3335Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04427 15.0002C6.04427 14.655 6.32409 14.3752 6.66927 14.3752H10.0026C10.3478 14.3752 10.6276 14.655 10.6276 15.0002C10.6276 15.3453 10.3478 15.6252 10.0026 15.6252H6.66927C6.32409 15.6252 6.04427 15.3453 6.04427 15.0002Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33594 0.208496C8.68112 0.208496 8.96094 0.488318 8.96094 0.833496V4.16683C8.96094 4.51201 8.68112 4.79183 8.33594 4.79183C7.99076 4.79183 7.71094 4.51201 7.71094 4.16683V3.12516H5.0026C4.42731 3.12516 3.96094 3.59153 3.96094 4.16683V16.6668C3.96094 17.2421 4.42731 17.7085 5.0026 17.7085H15.0026C15.5779 17.7085 16.0443 17.2421 16.0443 16.6668V4.16683C16.0443 3.59153 15.5779 3.12516 15.0026 3.12516H12.0859C11.7408 3.12516 11.4609 2.84534 11.4609 2.50016C11.4609 2.15498 11.7408 1.87516 12.0859 1.87516H15.0026C16.2683 1.87516 17.2943 2.90118 17.2943 4.16683V16.6668C17.2943 17.9325 16.2683 18.9585 15.0026 18.9585H5.0026C3.73695 18.9585 2.71094 17.9325 2.71094 16.6668V4.16683C2.71094 2.90118 3.73695 1.87516 5.0026 1.87516H7.71094V0.833496C7.71094 0.488318 7.99076 0.208496 8.33594 0.208496Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.6b390bc2584bc69354ea45b169302367.svg";
export { ForwardRef as ReactComponent };